module.exports = __webpack_public_path__ + "static/media/lib4.b294b863.jpg";